import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f1955c26&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1955c26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1955c26')) {
      api.createRecord('f1955c26', component.options)
    } else {
      api.reload('f1955c26', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f1955c26&scoped=true&", function () {
      api.rerender('f1955c26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/master_item/index.vue"
export default component.exports